import config from "../config";

/**
 * Checks the identity verification status for a given deposit.
 *
 * Sends a POST request to the verifyUserIdentity endpoint with the depositId.
 * If the user is already verified, resolves to { isVerified: true }.
 * Otherwise, returns { isVerified: false, verificationUrl }.
 *
 * @param {string} depositId - The deposit ID.
 * @returns {Promise<{isVerified: boolean, verificationUrl?: string}>} 
 *          A promise that resolves with an object indicating the identity status.
 * @throws {Error} If the API call fails.
 */
export async function contactus(email, subject, message) {
  const endpointUrl = `${config.API_BASE_URL}/contactus`;
  try {
    const response = await fetch(endpointUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, subject, message }),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Echec de l'envoi du message. Veuillez réessayer.");
    }

  } catch (error) {
    console.error("Error in contactus:", error);
    throw error;
  }
}